import PhoneInput from 'react-phone-number-input'

import 'react-phone-number-input/style.css'

export default function PhoneField({ label, value, onChange, className, inputClass, labelClass, placeholder, onBlur, type, required }) {
    return (
        <div className={className + ' mt-2'}>
            <label className={`block text-sm font-medium leading-6 text-neutral-600 ${labelClass}`}>
                {label} {required && <span className='text-red-500'>*</span>}
            </label>
            <div className='mt-1'>
                <PhoneInput defaultCountry='GB' value={value} onChange={onChange} />
                <p className='mt-1 text-sm text-gray-500'>Mobile numbers should include a country code (e.g. +44)</p>
            </div>
        </div>
    )
}
